import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function uiReducer(state = initialState.ui, action) {

    if (action.type === types.UI_RESIZE_WINDOW)
    {
        return { ...state, ...action.ui };
    }
    else if (action.type === types.SET_NEW_UI)
    {
        return { ...state, newUI: action.newUI };
    }
    else if (action.type === types.SET_DEVELOPER_MODE)
    {
        return { ...state, developerMode: action.developerMode };
    }
    else if (action.type === types.SET_HIDE_NEW_BUTTON)
    {
        return { ...state, hideNewButton: action.hideNewButton };
    }
    else {
        return state;
    }
}
